import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, Clock, Bell } from 'lucide-react';
import Layout from '../components/Layout';
import { PageHeader } from '../components/PageBits';
import { useCatalog } from '../context/CatalogContext';
import { fmtNum } from '../context/AppContext';
import { toast } from 'sonner';

function LiveCard({ s, large }) {
  const navigate = useNavigate();
  return (
    <div className={`ccard !w-full !aspect-[16/9] ${large ? '' : ''}`} onClick={() => (s.status === 'upcoming' ? toast.success(`Reminder set for ${s.title}`) : navigate(`/watch/${s.id}`))} data-testid={`live-${s.id}`}>
      <img src={s.image} alt={s.title} loading="lazy" />
      <div className="absolute inset-0" style={{ background: 'linear-gradient(0deg, rgba(5,6,12,0.92) 0%, rgba(5,6,12,0.2) 55%, transparent 100%)' }} />
      {s.status === 'live' && <span className="absolute top-2.5 left-2.5 flex items-center gap-1.5 bg-[#FF2E4D] text-white text-[10.5px] font-bold px-2 py-[3px] rounded"><span className="w-1.5 h-1.5 rounded-full bg-[#15121B] live-dot" />LIVE</span>}
      {s.status === 'upcoming' && <span className="absolute top-2.5 left-2.5 flex items-center gap-1.5 bg-black/70 border border-[#DDD6EC] text-white text-[10.5px] font-semibold px-2 py-[3px] rounded"><Clock size={11} />{s.startsAt}</span>}
      {s.status === 'recent' && <span className="absolute top-2.5 left-2.5 bg-black/70 border border-[#DDD6EC] text-white text-[10.5px] font-semibold px-2 py-[3px] rounded">REPLAY</span>}
      {s.status === 'live' && <span className="absolute top-2.5 right-2.5 flex items-center gap-1 bg-black/60 text-white text-[11px] font-medium px-2 py-[3px] rounded"><Eye size={12} />{fmtNum(s.viewers)}</span>}
      <div className="absolute left-3 right-3 bottom-3">
        <div className={`font-bold leading-tight ${large ? 'text-[18px]' : 'text-[14px]'}`}>{s.title}</div>
        <div className="text-[11.5px] text-[#C7C4CB] mt-0.5 flex items-center gap-2">{s.channel} <span className="w-[3px] h-[3px] rounded-full bg-[#15121B]/40" /> {s.category}{s.status === 'recent' && <><span className="w-[3px] h-[3px] rounded-full bg-[#15121B]/40" />{fmtNum(s.viewers)} views</>}</div>
      </div>
      {s.status === 'upcoming' && <span className="absolute right-3 bottom-3 icon-btn !w-8 !h-8"><Bell size={13} /></span>}
    </div>
  );
}

export default function Live() {
  const { liveStreams } = useCatalog();
  const live = liveStreams.filter((s) => s.status === 'live');
  const upcoming = liveStreams.filter((s) => s.status === 'upcoming');
  const recent = liveStreams.filter((s) => s.status === 'recent');
  return (
    <Layout>
      <PageHeader title="Live" subtitle="Concerts, sport, news and events streaming right now." />
      <section className="px-[22px]" data-testid="live-now">
        <h2 className="row-title mb-3 flex items-center gap-2"><span className="w-2 h-2 rounded-full bg-[#FF2E4D] live-dot" /> LIVE NOW <span className="text-[12px] text-[#8A8694] font-medium ml-1">{live.length} streams</span></h2>
        <div className="grid gap-[12px] grid-cols-1 md:grid-cols-2 xl:grid-cols-4">
          {live.map((s, i) => <LiveCard key={s.id} s={s} large={i === 0} />)}
        </div>
      </section>
      <section className="px-[22px] mt-8" data-testid="live-upcoming">
        <h2 className="row-title mb-3">Upcoming</h2>
        <div className="grid gap-[12px] grid-cols-2 md:grid-cols-3 xl:grid-cols-5">{upcoming.map((s) => <LiveCard key={s.id} s={s} />)}</div>
      </section>
      <section className="px-[22px] mt-8 pb-10" data-testid="live-recent">
        <h2 className="row-title mb-3">Recently Live</h2>
        <div className="grid gap-[12px] grid-cols-2 md:grid-cols-3 xl:grid-cols-5">{recent.map((s) => <LiveCard key={s.id} s={s} />)}</div>
      </section>
    </Layout>
  );
}
